import { Text } from '../../typography';
import s from './index.module.scss';

export const Footer = () => {
  return (
    <footer className={s.footer}>
      <Text size="2" color="3" className={s.text}>
        2019 - {new Date().getFullYear()} © Grigorii Zheliabin
      </Text>
    </footer>
  );
};
